<template>
  <div
    class="empty-div-content"
    :style="{
      'height': emptyHeight
    }"
  >
    <img
      class="empty-img"
      src="https://alphalawyer.cn/tool/images/charts-empty-data.svg"
    >
  </div>
</template>
<script>
export default {
  name: 'ChartEmpty',
  props: {
    emptyHeight: {
      type: String,
      default: '300px'
    }
  }
}
</script>
<style lang="stylus">
.empty
  &-div-content
    text-align: center;
    height: 100%;
  &-img
    position: relative
    width: 60%
    top: 20%
</style>
